<template>
  <div id="lunimgapp">
    <div class="lunbg">
      <div class="block">
        <el-carousel trigger="click" :height="bannerHeight + 'px'" :interval="3000">
          <el-carousel-item class="es-el-carousel__indicator" v-for="item in imagesbox" :key="item.id">
            <img :style="ifnull(item.toUrl) ? 'cursor: pointer' : ''" @click="isLetgodeta(item)"
              :src="downloadUrl + item.imgUrl" class="image">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { showNumber, bannerlist } from '@/api/projectSquare/xmgc'
export default {
  data() {
    return {
      // 交易总数
      bannerHeight: null, // 轮播高度
      // 最新发布(1),进行中(2)
      tabPosition: '1',
      // 假数据报名人数
      indehandata: ["2", "5", "6", "1", "2", "6", "12", "7", "4", "6"],
      downloadUrl: process.env.API_ROOT.substr(0, process.env.API_ROOT.length - 1),
      // downloadUrl: 'http://192.168.8.17:8888/gcapi',
      imagesbox: [],
      musicVoice: true, // 视频声音
    }
  },
  mounted() {
    this.setSize(window.innerWidth)
    // 窗口大小发生改变
    window.onresize = ({ targert }) => this.setSize(targert.innerWidth)
  },
  created() {
    this.getbannerimg('?type=0');// 更换参数获取不同的banner值   字典banner_type
  },
  methods: {
    setSize(width) {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = 600 / 1920 * width;
    },
    numberSerzi(data) {
      if (data != null) {
        return data.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
      } else {
        return;
      }
    },
    // 获取轮播图
    getbannerimg(type) {
      bannerlist(type).then(res => {
        this.imagesbox = res.data;
      }).catch(res => { })
    },
    // 声音开关
    videoVoice() {
      this.musicVoice = !this.musicVoice;
    },
    toPlay() {
      // this.$refs.videoPlayer.play()
      this.$refs.videoPlayer.paused === true ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
    },

    // 点击轮播图某一个或者按需 跳转至对应的页面
    isLetgodeta(item) {
      let tourl = this.ifnull(item.toUrl);
      if (tourl) {
        this.$router.push(item.toUrl);
      }
    },

    // 判断是否为空 返回 false  true
    ifnull(status) {
      if (status === '' || status === null || status === undefined) {
        return false
      } else {
        return true
      }
    }

  },
  components: {

  },
}
</script>

<style scoped>
.headtb {
  width: 100%;
  margin: 40px auto;
  display: flex;
  background: #E5F3FF;
  justify-content: space-between;
  border-radius: 4px;
}

.headtb-1 {
  width: 30%;
  text-align: center;
  padding: 24px;
}

.headtb-1 p {
  margin: 0;
}

.block {
  width: 100%;
  margin: 0 auto;
}

.el-carousel {
  width: 100%
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.image {
  width: 100%;
  height: inherit;
  margin: 0 auto;
  overflow: hidden;
  display: inline-block;
}

.lunbg {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #EEF9FF, #FDFEFF);
  /* margin-top: 56px;*/
  /*padding-top: 48px;*/
  /* padding-top: 2.875rem; */
  /* padding-bottom: 2.875rem;*/

}

/deep/ .el-carousel__button {
  background-color: #897e7e;
  opacity: 1;
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

/deep/ .el-carousel__indicator.is-active button {
  background-color: #F9B600;
  width: 25px;
  transition: 1s;
}

.es-el-carousel__indicator {
  background-repeat: no-repeat;
  background-position: center;
}

#lunimgapp {
  margin-top: 80px;
  background: #ffffff;
}

video {
  position: absolute;
  right: 0px;
  bottom: 0px;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
  /*加滤镜*/
  /*-webkit-filter: grayscale(100%);*/
  /*filter:grayscale(100%);*/
}

source {
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/lunbot.vue